export default "__VITE_ASSET__C450bqlD__"